import { first, throttle } from 'underscore';
import { useEffect, useCallback } from 'react';

import { LayoutSize, getLayoutSize } from './layout-size';

// eslint-disable-next-line no-unused-vars
type LayoutResizeObserverCallback = (size: LayoutSize) => void;

/**
 * A hook that calls the callback on window resize.
 * @param {LayoutResizeObserverCallback} callback - callback to call on resize
 * @param {number} throttleDalay - throttle delay in milliseconds, defaults to 10ms
 * @returns {void}
 */
export const useLayoutResizeObserver = (callback: LayoutResizeObserverCallback, throttleDalay: number = 10) => {
  const onObservation = useCallback(throttle((entries) => {
    const entry = first(entries);

    if (entry) {
      callback(getLayoutSize(entry.contentRect.width));
    }
  }, throttleDalay), [throttleDalay]);

  useEffect(() => {
    const resizeObserver = new (window as any).ResizeObserver(onObservation);

    resizeObserver.observe(document.body);

    return () => {
      resizeObserver.disconnect();
    };
  }, [callback, onObservation, throttleDalay]);
};
